import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService, Toast } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-container">
      @for (toast of toasts$ | async; track toast) {
        <div
          class="toast-item"
          [ngClass]="'toast-' + toast.type"
          (click)="removeToast(toast.id)">
          <div class="toast-icon">
            @if (toast.type === 'success') {
              <i class="fa fa-check-circle"></i>
            }
            @if (toast.type === 'error') {
              <i class="fa fa-times-circle"></i>
            }
            @if (toast.type === 'warning') {
              <i class="fa fa-exclamation-triangle"></i>
            }
            @if (toast.type === 'info') {
              <i class="fa fa-info-circle"></i>
            }
          </div>
          <div class="toast-message">{{ toast.message }}</div>
          <button class="toast-close" (click)="removeToast(toast.id)">
            <i class="fa fa-times"></i>
          </button>
        </div>
      }
    </div>
    `,
  styles: [`
    .toast-container {
      position: fixed;
      top: 30px;
      right: 20px;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 10px;
      max-width: 400px;
    }

    .toast-item {
      display: flex;
      align-items: center;
      padding: 14px 18px;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      animation: slideIn 0.3s ease-out;
      cursor: pointer;
      min-width: 300px;
      backdrop-filter: blur(10px);
    }

    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    .toast-icon {
      margin-right: 12px;
      font-size: 20px;
    }

    .toast-message {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
    }

    .toast-close {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 4px;
      margin-left: 10px;
      opacity: 0.7;
      transition: opacity 0.2s;
    }

    .toast-close:hover {
      opacity: 1;
    }

    /* Success Toast */
    .toast-success {
      background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
      border-left: 4px solid #28a745;
      color: #155724;
    }

    .toast-success .toast-icon {
      color: #28a745;
    }

    .toast-success .toast-close {
      color: #155724;
    }

    /* Error Toast */
    .toast-error {
      background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
      border-left: 4px solid #dc3545;
      color: #721c24;
    }

    .toast-error .toast-icon {
      color: #dc3545;
    }

    .toast-error .toast-close {
      color: #721c24;
    }

    /* Warning Toast */
    .toast-warning {
      background: linear-gradient(135deg, #fff3cd 0%, #ffeeba 100%);
      border-left: 4px solid #ffc107;
      color: #856404;
    }

    .toast-warning .toast-icon {
      color: #ffc107;
    }

    .toast-warning .toast-close {
      color: #856404;
    }

    /* Info Toast - Using Primary Color */
    .toast-info {
      background: linear-gradient(135deg, #e8e0ff 0%, #d9ccff 100%);
      border-left: 4px solid #5304fb;
      color: #3d0299;
    }

    .toast-info .toast-icon {
      color: #5304fb;
    }

    .toast-info .toast-close {
      color: #3d0299;
    }

    @media (max-width: 480px) {
      .toast-container {
        left: 10px;
        right: 10px;
        max-width: none;
      }

      .toast-item {
        min-width: auto;
      }
    }
  `]
})
export class ToastComponent {
  private toastService = inject(ToastService);
  toasts$ = this.toastService.toasts$;

  removeToast(id: number) {
    this.toastService.remove(id);
  }
}
